import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Fragment, PureComponent } from 'react';
import ResizeObserver from 'resize-observer-polyfill';
import PropTypes from 'prop-types';
import { findFirst, fromTo } from '@jd/jmtd-tools/es/generator';
import { css, px } from '@jd/jmtd-tools/es/css';
import classNames from '@jd/jmtd-tools/es/classnames';
import { setClass } from '@jd/jmtd-tools/es/element';
import Button from '@jd/jmtd/es/Button';
import Icon from '@jd/jmtd/es/Icon';
var CONTEXT = Symbol('context');

function ScrollButton(_ref) {
  var disabled = _ref.disabled,
      start = _ref.start,
      end = _ref.end,
      onClick = _ref.onClick;
  return /*#__PURE__*/React.createElement(Button, {
    className: classNames('jmtp-basic-summary-scroll-button-main', {
      'jmtp-basic-summary-scroll-button-start': start,
      'jmtp-basic-summary-scroll-button-end': end,
      'jmtp-basic-summary-scroll-button-disabled': disabled,
      'jmtp-basic-summary-scroll-button-enabled': !disabled
    }),
    link: true,
    dense: true,
    disabled: disabled,
    semantic: "primary",
    startIcon: /*#__PURE__*/React.createElement(Icon, {
      className: start ? 'jmti-angle-left' : 'jmti-angle-right'
    }),
    onClick: onClick
  });
}

ScrollButton.propTypes = {
  disabled: PropTypes.bool,
  end: PropTypes.bool,
  start: PropTypes.bool,
  onClick: PropTypes.func
};
ScrollButton.defaultProps = {
  disabled: false,
  end: false,
  start: false,
  onClick: function onClick() {}
};

var BasicSummaryWrapper = /*#__PURE__*/function (_PureComponent) {
  _inherits(BasicSummaryWrapper, _PureComponent);

  var _super = _createSuper(BasicSummaryWrapper);

  function BasicSummaryWrapper(props) {
    var _this;

    _classCallCheck(this, BasicSummaryWrapper);

    _this = _super.call(this, props);
    _this.scrollIndex = 0;
    return _this;
  }

  _createClass(BasicSummaryWrapper, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var ref = this.ref; // 如果table尺寸变化，重新计算尺寸

      var resizeObserver = this.resizeObserver = new ResizeObserver(function () {
        _this2.resize();
      });
      resizeObserver.observe(ref);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.resize();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.resizeObserver.disconnect();
    }
  }, {
    key: "measure",
    value: function measure(itemWidth) {
      var ref = this.ref,
          scrollButton = this.scrollButton,
          showLeftScrollButton = this.showLeftScrollButton,
          labelRef = this.labelRef,
          _this$props = this.props,
          items = _this$props.items,
          cardCountPerLine = _this$props.cardCountPerLine,
          showLabel = _this$props.showLabel,
          wrap = _this$props.wrap;
      var count = items.length;
      var scrollButtonWidth = scrollButton.offsetWidth; // 滚动按钮的宽度
      // 用于测量个数的宽度，除去label和滚动按钮宽度

      var maxWrapperWidth = ref.offsetWidth - (showLabel ? labelRef.offsetWidth : 0);
      var measureWidth = wrap ? maxWrapperWidth : maxWrapperWidth - scrollButtonWidth * (showLeftScrollButton ? 2 : 1); // 计算最大可显示的个数

      var maxItemsCount = findFirst(fromTo(cardCountPerLine, 0, -1), function (number) {
        return measureWidth - number * itemWidth + number - 1 > 0;
      }) || 1; // 是否展示滚动按钮

      var showScrollButton = !wrap && count > maxItemsCount; // 是否需要展示滚动按钮

      Object.assign(this, {
        scrollButtonWidth: scrollButtonWidth,
        maxWrapperWidth: maxWrapperWidth,
        maxItemsCount: maxItemsCount,
        showScrollButton: showScrollButton
      });
      return showScrollButton;
    }
  }, {
    key: "layout",
    value: function layout() {
      var scrollIndex = this.scrollIndex;
      var ref = this.ref,
          cardsWrapper = this.cardsWrapper,
          showLeftScrollButton = this.showLeftScrollButton,
          scrollButtonWidth = this.scrollButtonWidth,
          maxWrapperWidth = this.maxWrapperWidth,
          maxItemsCount = this.maxItemsCount,
          showScrollButton = this.showScrollButton,
          wrap = this.props.wrap;

      var cards = _toConsumableArray(cardsWrapper.children);

      var count = cards.length; // 计算可以用来显示卡片的宽度，除去label宽度，根据是否要展示滚动按钮除去滚动按钮宽度

      var remindWidth = maxWrapperWidth + maxItemsCount - 1;

      if (showScrollButton) {
        remindWidth -= showLeftScrollButton ? scrollButtonWidth * 2 : scrollButtonWidth;
      }

      var itemWidth = Math.round(remindWidth / maxItemsCount);
      var currentShowItemsIndex = {}; // 记录当前可视的卡片（没有滚动到屏幕外）的索引值

      var remindCount = maxItemsCount;
      var totalWidth = 0; // 调整滚动索引，防止尺寸变化时课时卡片过少的问题

      scrollIndex = Math.max(0, Math.min(count - remindCount, scrollIndex)); // 设置可视卡片的宽度，最后一项根据前几项的宽度动态调整

      var _iterator = _createForOfIteratorHelper(fromTo(scrollIndex, Math.min(scrollIndex + maxItemsCount, count))),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var index = _step.value;
          var thisWidth = remindCount === 1 ? remindWidth : itemWidth;
          totalWidth += thisWidth;
          css(cards[index], 'width', px(thisWidth));
          --remindCount;
          remindWidth -= itemWidth;
          currentShowItemsIndex[index] = true;
        } // 设置未显示出的卡片的宽度

      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      cards.forEach(function (card, index) {
        if (!currentShowItemsIndex[index]) {
          totalWidth += itemWidth;
          css(card, 'width', px(itemWidth));
        }
      });
      setClass(ref, 'jmtp-basic-summary-show-scroll-button', showScrollButton); // 是否展示滚动按钮

      setClass(ref, 'jmtp-basic-summary-scroll-disable-start', currentShowItemsIndex[0]); // 左侧按钮是否禁用

      setClass(ref, 'jmtp-basic-summary-scroll-disable-end', currentShowItemsIndex[count - 1]); // 右侧按钮是否禁用

      this.scrollIndex = scrollIndex;

      if (wrap) {
        var displayWidth = itemWidth * maxItemsCount;
        css(cardsWrapper, {
          width: px(displayWidth)
        });
        cards.forEach(function (child, index) {
          css(child, {
            'margin-left': index % maxItemsCount === 0 ? 0 : '-1px'
          });
          css(child, {
            'margin-top': index >= maxItemsCount ? '-1px' : 0
          });
        });
      } else {
        var _cards$scrollIndex$of, _cards$scrollIndex;

        css(cardsWrapper, {
          width: px(totalWidth),
          transform: "translate3d(".concat(px((_cards$scrollIndex$of = -((_cards$scrollIndex = cards[scrollIndex]) === null || _cards$scrollIndex === void 0 ? void 0 : _cards$scrollIndex.offsetLeft)) !== null && _cards$scrollIndex$of !== void 0 ? _cards$scrollIndex$of : 0), ",0,0)")
        });
      }
    }
  }, {
    key: "resize",
    value: function resize() {
      var cardsWrapper = this.cardsWrapper,
          ref = this.ref,
          grouped = this.props.grouped; // 没有尺寸时不计算尺寸
      // 如果在分组内，由父元素BasicSummaryGroupWrapper调用子元素的尺寸测量

      if (grouped || !ref.offsetWidth) {
        return;
      }

      ref.classList.add('jmtp-basic-summary-test'); // 是否需要展示滚动按钮

      this.measure(Math.max.apply(Math, _toConsumableArray(_toConsumableArray(cardsWrapper.children).map(function (node) {
        return node.offsetWidth;
      }))));
      ref.classList.remove('jmtp-basic-summary-test');
      this.layout();
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props2 = this.props,
          items = _this$props2.items,
          singleScrollButton = _this$props2.singleScrollButton,
          label = _this$props2.label,
          showLabel = _this$props2.showLabel,
          labelWidth = _this$props2.labelWidth,
          wrap = _this$props2.wrap,
          grouped = _this$props2.grouped;
      this.showLeftScrollButton = !label && !singleScrollButton; // 是否显示左侧滚动按钮

      var scrollButtonStart = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ScrollButton, {
        start: true,
        disabled: true
      }), /*#__PURE__*/React.createElement(ScrollButton, {
        start: true,
        onClick: function onClick() {
          _this3.scrollIndex -= _this3.maxItemsCount;

          _this3.layout();
        }
      }));
      var scrollButtonEnd = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ScrollButton, {
        end: true,
        disabled: true
      }), /*#__PURE__*/React.createElement(ScrollButton, {
        end: true,
        onClick: function onClick() {
          _this3.scrollIndex += _this3.maxItemsCount;

          _this3.layout();
        }
      }));
      return /*#__PURE__*/React.createElement("div", {
        "data-component-name": "Summary",
        className: classNames('jmtp-basic-summary-group', {
          'jmtp-basic-summary-group-with-label': showLabel
        }),
        ref: function ref(el) {
          _this3.ref = el;

          if (el) {
            el[CONTEXT] = _this3;
          }
        }
      }, showLabel && /*#__PURE__*/React.createElement("div", {
        className: "jmtp-basic-summary-label",
        ref: function ref(el) {
          _this3.labelRef = el;
        },
        style: {
          width: labelWidth
        }
      }, label), !wrap && this.showLeftScrollButton && /*#__PURE__*/React.createElement("div", {
        className: "jmtp-basic-summary-scroll-button jmtp-basic-summary-scroll-button-start"
      }, scrollButtonStart), wrap && /*#__PURE__*/React.createElement("div", {
        className: "jmtp-basic-summary-cards-disable-scroll-wrapper"
      }, /*#__PURE__*/React.createElement("div", {
        className: "jmtp-basic-summary-disable-scroll-cards-wrapper",
        ref: function ref(el) {
          _this3.cardsWrapper = el;
        }
      }, items.map(function (child, index) {
        return /*#__PURE__*/React.createElement(Fragment, {
          key: index
        }, child);
      }))), !wrap && /*#__PURE__*/React.createElement("div", {
        className: "jmtp-basic-summary-cards-scroll-wrapper"
      }, /*#__PURE__*/React.createElement("div", {
        className: "jmtp-basic-summary-cards-wrapper",
        ref: function ref(el) {
          _this3.cardsWrapper = el;
        }
      }, items.map(function (child, index) {
        return /*#__PURE__*/React.createElement(Fragment, {
          key: index
        }, child);
      }))), /*#__PURE__*/React.createElement("div", {
        className: classNames('jmtp-basic-summary-scroll-button', 'jmtp-basic-summary-scroll-button-end', {
          'jmtp-basic-summary-scroll-button-double': !this.showLeftScrollButton
        }),
        ref: function ref(el) {
          _this3.scrollButton = el;
        }
      }, this.showLeftScrollButton ? scrollButtonEnd : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: "jmtp-basic-summary-scroll-button-top jmtp-basic-summary-scroll-button-part"
      }, scrollButtonStart), /*#__PURE__*/React.createElement("div", {
        className: "jmtp-basic-summary-scroll-button-bottom jmtp-basic-summary-scroll-button-part"
      }, scrollButtonEnd))));
    }
  }]);

  return BasicSummaryWrapper;
}(PureComponent);

BasicSummaryWrapper.propTypes = {
  cardCountPerLine: PropTypes.number,
  items: PropTypes.array.isRequired,
  label: PropTypes.node,
  labelWidth: PropTypes.number,
  singleScrollButton: PropTypes.bool,
  showLabel: PropTypes.bool,
  grouped: PropTypes.any,
  wrap: PropTypes.bool
};
BasicSummaryWrapper.defaultProps = {
  cardCountPerLine: 5,
  label: null,
  labelWidth: null,
  singleScrollButton: false,
  showLabel: false,
  grouped: false,
  wrap: false
};

var BasicSummaryGroupWrapper = /*#__PURE__*/function (_PureComponent2) {
  _inherits(BasicSummaryGroupWrapper, _PureComponent2);

  var _super2 = _createSuper(BasicSummaryGroupWrapper);

  function BasicSummaryGroupWrapper() {
    _classCallCheck(this, BasicSummaryGroupWrapper);

    return _super2.apply(this, arguments);
  }

  _createClass(BasicSummaryGroupWrapper, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this4 = this;

      var ref = this.ref; // 如果table尺寸变化，重新计算尺寸

      var resizeObserver = this.resizeObserver = new ResizeObserver(function () {
        _this4.resize();
      });
      resizeObserver.observe(ref);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.resize();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.resizeObserver.disconnect();
    }
  }, {
    key: "resize",
    value: function resize() {
      var ref = this.ref; // 如果没有尺寸，不进行尺寸计算

      if (!ref.offsetWidth) {
        return;
      }

      ref.classList.add('jmtp-basic-summary-test');
      var maxCardWidth = Math.max.apply(Math, _toConsumableArray(_toConsumableArray(ref.querySelectorAll('.jmtp-basic-summary-card')).map(function (node) {
        return node.offsetWidth;
      })));

      var subComponents = _toConsumableArray(ref.querySelectorAll('.jmtp-basic-summary-group')).map(function (group) {
        return group[CONTEXT];
      });

      var showScrollButton = subComponents.map(function (comp) {
        return comp.measure(maxCardWidth);
      }).some(function (x) {
        return x;
      });
      ref.classList.remove('jmtp-basic-summary-test');
      subComponents.forEach(function (comp) {
        comp.showScrollButton = showScrollButton;
        comp.layout();
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this5 = this;

      var _this$props3 = this.props,
          children = _this$props3.children,
          className = _this$props3.className;
      return /*#__PURE__*/React.createElement("div", {
        className: className,
        ref: function ref(el) {
          _this5.ref = el;
        }
      }, children);
    }
  }]);

  return BasicSummaryGroupWrapper;
}(PureComponent);

BasicSummaryGroupWrapper.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node
};
BasicSummaryGroupWrapper.defaultProps = {
  className: null,
  children: null
};
export default function BasicSummary(props, _ref2) {
  var getItems = _ref2.getItems,
      grouped = _ref2.grouped,
      hasLabel = _ref2.hasLabel;
  return {
    className: 'jmtp-basic-summary',
    group: true,
    Component: BasicSummaryWrapper,
    GroupedComponent: BasicSummaryGroupWrapper,
    cardProps: function cardProps() {
      return {
        className: 'jmtp-basic-summary-card'
      };
    },
    getProps: function getProps(data) {
      return _objectSpread(_objectSpread({}, props), {}, {
        showLabel: hasLabel,
        grouped: grouped,
        items: getItems(data).map(function (item) {
          return item.children;
        })
      });
    }
  };
}